const accounts = [
  {
    username: "manuelslourenco@gmail.com",
    name: "Manuel Lourenço",
    password: "601f1889667efaebb33b8c12572835da3f027f78", //123123
    role: "SUPERADMIN",
    projects: ["LOCAL", "DUMMY", "ANANDA"],
  },
  {
    username: "alexandre.ferreiradasilva@gmail.com",
    name: "Alexandre Ferreira da Silva",
    password: "601f1889667efaebb33b8c12572835da3f027f78", //123123
    role: "SUPERADMIN",
    projects: ["DUMMY", "ANANDA"],
  },
  {
    username: "simao.peca@gmail.com",
    name: "Simão Alves",
    password: "601f1889667efaebb33b8c12572835da3f027f78", //123123
    role: "SUPERADMIN",
    projects: ["DUMMY", "ANANDA"],
  },
];

export const projects = [
  {
    id: "DUMMY",
    name: "Dummy", 
  },
  {
    id: "ANANDA",
    name: "Ananda Valley", 
  },
  {
    id: "LOCAL",
    name: "PI on localhost", 
  },
  {
    id: "SCRIPTHORIUMPI",
    name: "scripthoriumpi.solarpunk.pro", 
  }
]

export function login(username, password) {
  // console.log("LOGIN");
  // console.log(username, password);
  // console.log('accounts: %o', accounts);
  let account = accounts.find((item) => {
    return item.username === username && item.password === password;
  });
  // console.log('account: %o', account);
  return account;
}
